{
  "title": "Net Worth",
  "table": "Table",
  "chart": "Bar Chart",
  "accordion": "Accordion",
  "assets": "Assets",
  "liabilities": "Liabilities",
  "currentNetWorth": "Current Net Worth",
  "downloadProgressTitle": "Packaging net worth data",
  "lastUpdated": "Last updated",
  "accountSourceType": {
    "INTERNAL": "INTERNAL",
    "EXTERNAL": "EXTERNAL"
  },
  "categories": {
    "INTERNAL": "Internal Investments",
    "CASH": "Cash",
    "EXTERNAL_INVESTMENT_ACCOUNT": "External Investments",
    "REAL_ESTATE": "Real Estate",
    "VEHICLES": "Vehicles",
    "VALUABLES": "Valuables",
    "OTHER_ASSET": "Other",
    "LOANS": "Loans",
    "MORTGAGE": "Mortgage",
    "CREDIT_CARD": "Credit Card",
    "OTHER_LIABILITY": "Other"
  },
  "netWorthTable": {
    "financialAccounts": "Financial Accounts",
    "asset": "Asset",
    "liability": "Liability",
    "noNetWorthData": "No net worth data found",
    "total": "Total:",
    "downloadColumns": {
      "accountId": "Account ID",
      "firstName": "User First Name",
      "lastName": "User Last Name",
      "entityName": "Entity Name",
      "accountType": "Account Type",
      "accountNickname": "Account Nickname",
      "value": "Value",
      "source": "Source",
      "category": "Category",
      "organization": "Organization",
      "user": "User"
    }
  },
  "editNetWorth": {
    "title": "Edit an asset or liability",
    "type": "Type",
    "accountNickname": "Account Nickname",
    "value": "Value",
    "delete": "Delete",
    "save": "Save",
    "deleteConfirmation": {
      "title": "Delete {{accountName}} account?",
      "bodyText": "Are you sure you want to delete this item?"
    }
  },
  "netWorthAccordion": {
    "noNetWorthData": "No net worth data found"
  },
  "netWorthChart": {
    "emptyChart": "No data found"
  },
  "addNetWorthManually": {
    "title": "Add manual account",
    "nickname": "Nickname",
    "value": "Value",
    "currency": "Currency",
    "currencies": {
      "USD": "US Dollar",
      "CAD": "Canadian Dollar"
    }
  },
  "addNetWorthAutomatically": {
    "linkingTimeInfo": "Linking may take up to 5 minutes...",
    "noIntegration": "No integration found",
    "linkSuccess": "Linking successful",
    "linkError": "Linking failed",
    "netWorthAutomaticLink": {
      "title": "Linking net worth",
      "syncMessage": "Your accounts are being synced.",
      "notificationMessage": "You will be notified when the accounts are ready.",
      "notificationSuccessTitle": "Plaid Accounts Synced.",
      "notificationSuccessBody": "Your net worth is updated.",
      "notificationFailureTitle": "Plaid Accounts Sync Failed.",
      "notificationFailureBody": "Please try again.",
      "notificationLinkText": "Thanks"
    }
  }
}
